 
import * as yup from 'yup'


export const SigninSchema = yup.object().shape({
    email: yup.string().email().required('email is a required field'),
    password: yup.string().required('password is a required field'),
})